import { useMemo } from 'react'
import { isNonNullable } from 'lib/array/arrayUtils'
import type { LoyaltyEligibleOffer } from 'loyalty/lib/esimOfferEligibility'
import useLoyaltyEsimInclusion, { useTourVariationLoyaltyEsimInclusion } from 'loyalty/hooks/useLoyaltyEsimInclusion'

/**
 * Returns all Société loyalty benefit inclusions for a given offer and/or tour variation.
 * Centralises the determination of which loyalty benefits apply — adding a new benefit
 */
export default function useLoyaltyBenefitInclusions(
  offer?: LoyaltyEligibleOffer,
  variation?: App.Tours.TourV2OfferVariation,
): Array<App.OfferInclusion> {
  const offerEsim = useLoyaltyEsimInclusion(offer)
  const variationEsim = useTourVariationLoyaltyEsimInclusion(variation)
  const esim = variation ? variationEsim : offerEsim

  return useMemo(
    () => [esim].filter(isNonNullable),
    [esim],
  )
}
